var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"avatar",class:_vm.avatarClass,style:(_vm.avatarStyle)},[(_vm.presence)?_c('span',{staticClass:"presence",class:_vm.presenceClass,style:(_vm.presenceStyle)}):_vm._e(),(!_vm.hasImage && !_vm.identicon)?_c('span',{staticClass:"initials"},[_vm._v(_vm._s(_vm.initials))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }